<template>
    <div class="card mt-3">
        <div class="card-header bg-success text-white">
            <span>Тарихи</span>
            <div class="margin-top-10 bold-text">
                Сарф қилинган вақт: {{spentTime}}
            </div>
        </div>
        <div class="card-body">
            <div class="table-responsive tableFixHead">
                <div class="table-wrapper">
                  <table class="table">
                      <thead>
                      <tr>
                          <th>№</th>
                          <th >Сана</th>
                          <th >Томонидан</th>
                          <th >Амал</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(history, index) in results" :key="history.id">
                          <td>{{index+1}}</td>
                          <td>{{new Date(history.eventDate) | dateFormat('DD/MM/YYYY HH:mm')}}</td>
                          <td>{{history.userName}}</td>
                          <td>{{history.displayName!=null? history.displayName: history.auditEventActionDisplayName}} </td>
                      </tr>
                      </tbody>
                  </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                realEstateId: null,
                results: [],
                spentTime: ''
            }
        },
        methods: {
            formatDate(firstDate, lastDate) {
                var last = new Date(lastDate);
                var first = new Date(firstDate);
                var diffMs = Math.abs(last - first); // milliseconds between now & Christmas
                var diffDays = Math.floor(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
                this.spentTime = (diffDays ? diffDays + " гун " : "") + (diffHrs ? diffHrs + ' соат ' : '') + (diffMins ? diffMins + ' мин ' : '');
            },
            init() {
                const vm = this;
                this.$http.get('/fitment-history/' + this.$route.params.id)
                    .then(res => {
                        vm.results = res.data;
                        if (vm.results.length > 1) {
                            const firstDate = vm.results[0].eventDate;
                            const lastDate =  vm.results[vm.results.length - 1].eventDate;
                            this.formatDate(firstDate, lastDate);
                        }

                    }, err => {
                        console.log(err);
                    });
            }
        },
        created() {
            this.init();
        }

    }
</script>

<style scoped>
    table {
        border-collapse: collapse;
        width: 100%;
    }

    th {
        background: #eee;
    }

    .tableFixHead {
        overflow-y: auto;
        max-height: 300px;
    }

    .tableFixHead thead th {
        position: sticky;
        top: 0;
    }
</style>